import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Card,
  Form,
  Input,
  Button,
  Typography,
  Alert,
  Space,
  Tag,
} from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { http } from "@/api/client";
import type { LoginResponse } from "@/types/common";
import { useAuth } from "@/stores/auth";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const setSession = useAuth((s) => s.setSession);

  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? "/";

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await http.post<LoginResponse>("/auth/login", {
        ...values,
        device_id: "admin-web-" + (navigator.userAgent?.length ?? 0),
      });
      setSession(data.access_token, data.user);
      // axios 拦截器从 localStorage 读 token，所以也写一份
      localStorage.setItem("admin_access_token", data.access_token);
      navigate(from, { replace: true });
    } catch (err) {
      const e = err as { response?: { data?: { message?: string } } };
      setError(e.response?.data?.message ?? "登录失败，请检查用户名密码");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1677ff 0%, #4096ff 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 420,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          borderRadius: 12,
        }}
        styles={{ body: { padding: "40px 36px" } }}
      >
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>🩺</div>
            <Typography.Title level={3} style={{ margin: 0 }}>
              心音 · 管理后台
            </Typography.Title>
            <Typography.Text type="secondary">
              V1.0 · 内容生产端
            </Typography.Text>
          </div>

          {error && <Alert type="error" message={error} showIcon closable />}

          <Form
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ username: "admin", password: "admin" }}
          >
            <Form.Item
              label="用户名"
              name="username"
              rules={[{ required: true, message: "请输入用户名" }]}
            >
              <Input
                size="large"
                prefix={<UserOutlined />}
                placeholder="admin"
                autoComplete="username"
              />
            </Form.Item>
            <Form.Item
              label="密码"
              name="password"
              rules={[{ required: true, message: "请输入密码" }]}
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                placeholder="admin"
                autoComplete="current-password"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={loading}
              >
                登录
              </Button>
            </Form.Item>
          </Form>

          <Alert
            type="info"
            showIcon
            message={
              <Space>
                <span>演示账号：</span>
                <Tag color="blue">admin</Tag>
                <span>/</span>
                <Tag color="blue">admin</Tag>
              </Space>
            }
          />
        </Space>
      </Card>
    </div>
  );
}
